/**
 * 내 계정 — 이름·회사명·연락처 (261013-account-brand-membership). 브랜드와 무관한 계정 단위 설정이다.
 * 승인 대기 중에도 쓴다(http.ts PENDING_ALLOWED)
 */
import { z } from 'zod';
import { IsoDateTime } from '../common.ts';
import { defineRoute } from '../route.ts';
import { Phone } from './signup.ts';

export const AccountProfile = z.object({
  email: z.string(),
  name: z.string().nullable(),
  companyName: z.string().nullable(),
  phone: z.string().nullable(),
  marketingAgreedAt: IsoDateTime.nullable(),
});

export const getAccount = defineRoute({
  method: 'get',
  path: '/api/account/profile',
  access: 'session',
  summary: '내 계정 정보',
  response: z.object({ account: AccountProfile }),
});

/**
 * 내 계정 수정. ★ **이메일·휴대폰을 바꾸면 새 값의 인증이 필요하다** — 가입과 같은 인증 흐름
 * (`/api/signup/{email,phone}/*`)으로 인증한 미소비 행이 있어야 하고, 저장과 같은 트랜잭션에서 소비한다
 */
export const updateAccount = defineRoute({
  method: 'patch',
  path: '/api/account/profile',
  access: 'session',
  summary: '내 계정 수정 — 이름·회사명·이메일·휴대폰(바꾸면 새 값을 먼저 인증)',
  body: z
    .object({
      name: z.string().trim().min(1).max(60).optional(),
      companyName: z.string().trim().max(120).nullable().optional(),
      email: z.email().optional(),
      phone: Phone.optional(),
    })
    .strict(),
  response: z.object({ account: AccountProfile }),
});
